module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('v-cells', {
    attrs: {
      "paddingBottom": "8pt",
      "paddingTop": "3pt",
      "paddingLeft": "16pt",
      "paddingRight": "16pt"
    }
  }, [_c('v-item-cell', {
    attrs: {
      "leftText": "充值详情",
      "leftColor": "black"
    }
  }), _vm._v(" "), _c('v-item-cell', {
    attrs: {
      "leftText": "充值金额",
      "rightText": _vm.formatPrice(_vm.data.rechargeAmount)
    }
  }), _vm._v(" "), _c('v-item-cell', {
    attrs: {
      "leftText": "充值时间",
      "rightText": _vm.formatTime(_vm.data.rechargeTime),
      "rightColor": "#A0A1A3"
    }
  }), _vm._v(" "), _c('v-item-cell', {
    attrs: {
      "leftText": "充值类型",
      "rightText": _vm.resource.rechargeType.values[_vm.data.rechargeType],
      "rightColor": "#090A0A"
    }
  }), _vm._v(" "), _c('v-item-cell', {
    attrs: {
      "leftText": "订单号",
      "rightText": _vm.data.outPayTradeNo,
      "rightColor": "#090A0A"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64a0ed5d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pg/recharge-detail.vue
// module id = 858
// module chunks = 34